import React from "react";
import { withScrollTo } from "../components/ScrollTo";

// 首页
import IndexPage from "../pages/Home";
import DigitalResourceLibraryHome from "../pages/DigitalResourceLibrary/Home";
import GuQin from "../pages/DigitalResourceLibrary/GuQin";
import ImgList from "../pages/DigitalResourceLibrary/ImgList";
import Detail from "../pages/DigitalResourceLibrary/Detail";
import Game from "../pages/Game";
import Play from "../pages/Game/Play";
import Pic from "../pages/Game/Play/Pic";
import LLK from "../pages/LLK";
import LLKGame from "../pages/LLK/LLKGame";
import Choose from "../pages/LLK/LLKGame/Choose";
import QYQW from "../pages/GQKP/QYQW";
import QZCG from "../pages/GQKP/QZCG";
import GQKP from "../pages/GQKP";
import QHXZ from "../pages/GQKP/QHXZ";
import Detail2 from "../pages/GQKP/Detail";
import { Navigate } from "react-router-dom";
const mainRoutes = [
  {
    path: "/",
    element: <IndexPage />,
    exact: true,
  },
  {
    path: "/Home",
    element: <IndexPage />,
    exact: true,
  },
  {
    path: "/Game",
    element: <Game />,
    exact: true,
  },
  {
    path: "/Game/Play",
    element: <Play />,
    exact: true,
  },
  {
    path: "/Game/Play/Pic",
    element: <Pic />,
    exact: true,
  },
  {
    path: "/LLK",
    element: <LLK />,
    exact: true,
  },
  {
    path: "/LLK/LLKGame",
    element: <LLKGame />,
    exact: true,
  },
  {
    path: "/LLK/Choose",
    element: <Choose />,
    exact: true,
  },
  {
    path: "/DigitalResourceLibrary/Home",
    element: React.createElement(withScrollTo(DigitalResourceLibraryHome)),
    exact: true,
  },
  {
    path: "/DigitalResourceLibrary/Guqin",
    element: React.createElement(withScrollTo(GuQin)),
    exact: true,
  },
  {
    path: "/DigitalResourceLibrary/Book",
    element: React.createElement(withScrollTo(ImgList)),
    exact: true,
  },
  {
    path: "/DigitalResourceLibrary/Qinpu",
    element: React.createElement(withScrollTo(ImgList)),
    exact: true,
  },
  {
    path: "/DigitalResourceLibrary/Qinqu",
    element: React.createElement(
      withScrollTo(ImgList), // 用 withScrollTo 包裹，并传递 anchor
      {
        type: "text",
        size: window.isWap ? 10 : 21,
      } // 传递 ImgList 的 props
    ),
    exact: true,
  },
  {
    path: "/DigitalResourceLibrary/GuQin/:channelNo",
    element: <ImgList type="masonry" size={20} />,
    exact: true,
  },
  {
    path: "/DigitalResourceLibrary/GuQin/:channelNo/:id",
    element: React.createElement(withScrollTo(Detail)),
    exact: true,
  },
  {
    path: "/DigitalResourceLibrary/:channelNo/:id",
    element: React.createElement(withScrollTo(Detail)),
    exact: true,
  },
  {
    path: "/GQKP",
    element: <GQKP />,
    exact: true,
  },

  {
    path: "/GQKP/QZCG",
    element: <QZCG />,
    exact: true,
  },
  {
    path: "/GQKP/QHXZ",
    element: <Navigate to="/GQKP/FamousAppreciation" />,
    exact: true,
  },
  {
    path: "/GQKP/FamousAppreciation",
    element: <QHXZ />,
    exact: true,
  },

  {
    path: "/GQKP/QHXZ-MustRead",
    element: <QHXZ />,
    exact: true,
  },
  {
    path: "/GQKP/GQSelectedTrack",
    element: <QHXZ />,
    exact: true,
  },
  {
    path: "/GQKP/QYQW",
    element: <Navigate to="/GQKP/QXStart-MustRead" />,
    exact: true,
  },
  {
    path: "/GQKP/:sec",
    element: <QYQW />,
    exact: true,
  },
  {
    path: "/GQKP/:sec/:id",
    element: React.createElement(withScrollTo(Detail2)),
    exact: true,
  },
  {
    path: "/GQKP/:sec/:third/:id",
    element: React.createElement(withScrollTo(Detail2)),
    exact: true,
  },
];

export const pcRoutes = mainRoutes.concat();
